import React from 'react';
import { useTranslation } from 'react-i18next';

interface ConnectorLinkCardProps {
  href: string;
  name: string;
  icon: React.ReactNode;
  description: string;
}

// Rendered inside a markdown <p> (often inside **bold**), so it uses spans and resets font weight.
export const ConnectorLinkCard: React.FC<ConnectorLinkCardProps> = ({ href, name, icon, description }) => {
  const { t } = useTranslation();

  return (
    <span className="my-3 flex w-full items-center gap-3 rounded-xl border border-grey-100 bg-white p-4 font-normal shadow-choice-card dark:border-border dark:bg-card sm:gap-4 sm:p-5">
      <span className="flex size-7 shrink-0 items-center justify-center overflow-hidden rounded border border-grey-100 bg-true-white dark:border-border [&>img]:size-6 [&>svg]:size-6">
        {icon}
      </span>
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="text-base font-medium leading-5 text-grey-950 dark:text-foreground">{name}</span>
        <span className="break-words text-sm leading-5 text-grey-900 dark:text-muted-foreground">
          {description}
        </span>
      </span>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="shrink-0 rounded-full bg-grey-950 px-4 py-1.5 text-xs font-medium leading-body text-true-white no-underline transition-opacity hover:opacity-80 active:scale-95 dark:bg-true-white dark:text-grey-950"
      >
        {t('CONNECT')}
      </a>
    </span>
  );
};
